module.exports = require('./helpers/bundle-url').getBundleURL('1iIZY') + "logo.c51670a8.svg";